import {baseUrl} from '../shared/baseUrl';


// Get AUDIO for verification
export var isAdmin = ()=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    if (!bearer) {
        console.log("No token found in localStorage");
        return;
    }

    return fetch(baseUrl+'admin6089/isAdmin',{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

// Get AUDIO for verification
export var getActiveUsersCount = (hours,minRecord,maxRecord,minVerify,maxVerify)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/users/count/'+hours+'/'+minRecord+'/'+maxRecord+'/'+minVerify+'/'+maxVerify,{
        method: 'GET',
        // body:JSON.stringify({
        //     hours:hours
        // }),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export var getActiveUsersList = (hours,minRecord,maxRecord,minVerify,maxVerify)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/users/list/'+hours+'/'+minRecord+'/'+maxRecord+'/'+minVerify+'/'+maxVerify,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export var getSpecificUser = (username)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/users/username/'+username,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}


// Functions For Audio 
export var getAudioCountServer = (hours)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/audio/count/time/'+hours,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

// Function to Get count of Verified Audio in specified time frame
// Functions For Audio 
export var getAudioVerifyCountServer = (hours)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/audio/verified/count/time/'+hours,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

// get list of correct audio evaluated in specific time frame
export var getCorrectAudioListServer = (hours,maxNumber)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/audio/correctList/time/'+hours+'/'+maxNumber,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

// get Wrong List of audio evaluated in specific time frame
export var getWrongAudioListServer = (hours,maxNumber)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/audio/wrongList/time/'+hours+'/'+maxNumber,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export var getSpecificAudioServer = (fileNumber)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/audio/file/'+fileNumber,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export const changeVerificationResult = (audioId) =>{
    var dataload = {
        _id:audioId,
        verificationResult:1
    }
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio',{
        method: 'PUT',
        body: JSON.stringify(dataload),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}

export const deleteAudioWithId = (audioId,hindiTextId) =>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio/specificFile/'+audioId+'/'+hindiTextId,{
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}



// Functions for getting Text
export var getSpecificTextServer = (fileNumber)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/text/file/'+fileNumber,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export const deleteTextWithId = (hindiTextId,fileNumber) =>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/text/fileDelete/'+hindiTextId+'/'+fileNumber,{
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}

// export const uploadNewFilesToDb = (start,end) =>{
//     const bearer = 'Bearer ' + localStorage.getItem('token');
//     return fetch(baseUrl+'admin6089/text/upload/'+start+'/'+end,{
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             'Authorization': bearer
//           },
//         credentials: 'same-origin'
//     })
//     .then(response =>{
//         if(response.ok){
//             return response;
//         }
//         else{
//             var error = new Error("Response failed!!");
//             error.response = response;
//             throw error;
//         }
//     },(err)=>{
//         var errmess = new Error(err.message+"hulalalala")
//         throw errmess;
//     })
//     .then(response=>{
//         return response.json();
//     })
//     .catch((err)=>console.log(err));
// }

export const uploadNewFilesToDb = (fileNumber) =>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'admin6089/text/uploadText/'+fileNumber,{
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}